<script setup lang="ts">
import { cn } from '@/lib/utils';
import type { HTMLAttributes } from 'vue';

const props = defineProps<{
  class?: HTMLAttributes['class'];
}>();
</script>

<template>
  <th
    :class="
      cn('h-12 px-4 text-left align-middle font-medium text-grey-light-600 [&:has([role=checkbox])]:pr-0', props.class)
    "
  >
    <slot />
  </th>
</template>
